export abstract class SelectOptionBase {}
